import axios from 'axios';
import { authProvider } from '../../auth/authProvider';
import { API } from '../Constants';

//RITM0958798 - HOC Download Fix
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const timeout = setTimeout(() => {
  source.cancel();
  // Timeout Logic
}, 1800000);
//End

const http = axios.create({
  // withCredentials: false,
  baseURL: `${process.env.REACT_APP_API_URL}api`, // 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_GATEWAY_SUBSCRIPTION
    // 'Cache-Control': 'no-cache',
    // Pragma: 'no-cache',
    //  Expires: '0'
  },
});

const httpMultiPart = axios.create({
  // withCredentials: false,
  timeout: 600000, // Set a timeout of 5 seconds
  baseURL: `${process.env.REACT_APP_API_URL}api`, // 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'multipart/form-data',
    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_GATEWAY_SUBSCRIPTION
  },
});

const findInvalidCharactersInObject = (obj) => {
  if (obj == null) return;

  if (typeof obj === 'string') {
    const hasInvalidCharacters = /[\u0000-\u0008\u000b-\u000c\u000e-\u001f\u007f]+/.test(obj);
    return hasInvalidCharacters;
  }

  if (typeof obj === 'object') {
    for (const [key, value] of Object.entries(obj)) {
      const result = findInvalidCharactersInObject(value);
      if (result === true) {
        console.log('Invalid characters are in field: ', key, ' with value: ', value);
        return true;
      }
    }
  }
    return false;
};

const invalidCharactersInterceptor = (config) => {
  if (config?.method !== 'put' && config?.method !== 'post') return;

  const hasInvalidCharacters = findInvalidCharactersInObject(config.data);
  if (hasInvalidCharacters) {
      console.log('The submitted data contains invalid characters', config?.data);
      throw { message: 'The submitted data contains invalid characters. Please check and try to submit again.' };
  }
};

http.interceptors.request.use(
  async (config) => {
    invalidCharactersInterceptor(config);
    const token = await authProvider.getAccessToken();
    if (token){
      config.headers.Authorization = `Bearer ${token.accessToken}`;
      config.headers['Authorization'] = `Bearer ${token.accessToken}`;
    } 
    return Promise.resolve(config);
  },
  (error) => Promise.reject(error)
);

httpMultiPart.interceptors.request.use(
  async (config) => {
    invalidCharactersInterceptor(config);
    const token = await authProvider.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token.accessToken}`;
      config.headers['Authorization'] = `Bearer ${token.accessToken}`;
    }
    return Promise.resolve(config);
  },
  (error) => Promise.reject(error)
);

// API URL Parametrico
export const api = {
  get: (url, id) => http.get(url + id),
  getAll: (url) => http.get(url),
  post: (url, o) => http.post(url, o),
  put: (url, o, id) => http.put(`${url}${id || ''}`, o),
  delete: (url, id) => http.delete(url + id),
  deleteData: (url, data) => http.delete(url, { data }),
  getWithParam: (url, o) => http.get(url, o),
  upload: (url, data) => httpMultiPart.post(url, data),
  getBlob: (url) => http.get(url, { responseType: 'blob' }),
  postBlob: (url, o) => http.post(url, o, { responseType: 'blob' }),
};

// API URL Specifico
export const todos = {
  get: (id) => http.get(API.TODOS + id),
  getAll: () => http.get(API.TODOS),
  post: (o) => http.post(API.TODOS, o),
  put: (o, id) => http.put(API.TODOS + id, o),
  delete: (id) => http.delete(API.TODOS + id),
};

export const me = {
  get: (url, id) => http.get(API.ME + url + id),
  getAll: (url) => http.get(API.ME + url),
  getMe: () => http.get(API.ME),
  post: (url, o) => http.post(API.ME + url, o),
  put: (url, o, id) => http.put(API.ME + url + id, o),
  delete: (url, id) => http.delete(API.ME + url + id),
  getWithParam: (url, o) => http.get(API.ME + url, o),
};

// API UTL Audit
export const audit = {
  getAll: (url) => http.get(API.AUDIT + url),
  getWithParam: (url, o) => http.get(`${API.AUDIT + url}`, o),
  put: (url, o, id) => http.put(API.AUDIT + url + id, o),
  post: (url, o) => http.post(API.AUDIT + url, o),
  deleteAttach: (url) => http.delete(url),
  downloadReport: (url) => http.get(url),
};
// API URL Incident
export const incident = {
  getAttachment: (idIncident, o) => http.get(`${API.INCIDENT + idIncident}/attachment`, o),
  getAll: () => http.get(API.INCIDENT),
  getWithParam: (o) => http.get(API.INCIDENT, o),
  downloadNotification: (idIncident, o) => http.get(`${API.INCIDENT}notification/${idIncident}`, o),
  downloadReport: (idIncident, o) => http.get(`${API.INCIDENT}report/${idIncident}`, o),
};
// API URL Training
export const training = {
  // getAttachment: (idIncident, o) => http.get(`${API.INCIDENT + idIncident}/attachment`, o),
  get: (url, id) => http.get(API.TRAINING + url + id),
  getAll: () => http.get(API.TRAINING),
  getWithParam: (o) => http.get(API.TRAINING, o),
  // downloadNotification: (idIncident, o) => 
  //    http.get(`${API.INCIDENT}notification/${idIncident}`, o),
  downloadCertificate: (idTraining, o) => http.get(`${API.TRAINING}certificate/${idTraining}`, o),
};
export const inspection = {
  // getAttachment: (idIncident, o) => http.get(`${API.INCIDENT + idIncident}/attachment`, o),
  get: (id) => http.get(API.INSPECTION + id),
  getAll: () => http.get(API.INSPECTION),
  put: (o, id) => http.put(API.INSPECTION + id, o),

  getWithParam: (o) => http.get(`${API.INSPECTION}calendarPaged/`, o),
  getCalendar: (o) => http.get(`${API.INSPECTION}calendar/`, o),

  getInspectors: (id) => http.get(`${API.INSPECTION}inspectors/${id}`),
  post: (o) => http.post(API.INSPECTION, o),
  deleteAttach: (url) => http.delete(url),
  // downloadNotification: (idIncident, o) => 
  //    http.get(`${API.INCIDENT}notification/${idIncident}`, o),
  // downloadReport: (idIncident, o) => http.get(`${API.INCIDENT}report/${idIncident}`, o)
};

export const drill = {
  get: (id) => http.get(API.DRILL + id),
  getAll: () => http.get(API.DRILL),
  getCalendar: (o) => http.get(`${API.DRILL}calendar/`, o),

  put: (o, id) => http.put(API.DRILL + id, o),
  post: (o) => http.post(API.DRILL, o),
  deleteAttach: (url) => http.delete(url),

  getReport: (id) => http.get(`${API.DRILL}report/${id}`),
  getReportCalendar: (o) => http.get(`${API.DRILL}reports/calendar/`, o),

  getAllWorksiteAttachments: (id) => http.get(`${API.DRILL}${id}/alldrillplanbyworksiteattachments`),
  //RITM0958089 & RITM0963328 - Drill Year Filter Fix
  drillYears: {
    getAll: () => http.get(`${API.DRILL}drillYears`)
  },
  getDrillsWorksites: (year) => http.get(`${API.DRILL}drillsWorksites/${year}`),
  getDrillsProjects: (year) => http.get(`${API.DRILL}drillsProjects/${year}`),
  //End
};
export const kpi = {
  get: (id) => http.get(API.KPI + id),
  getAll: () => http.get(`${API.KPI}all/`),
  getWithParam: (o) => http.get(API.KPI, o),
  geToChange: (o) => http.post(`${API.KPI}entity/`, o),
  put: (o) => http.post(`${API.KPI}edit/`, o),
  post: (o) => http.post(API.KPI, o),
  delete: (o) => http.post(`${API.KPI}delete/`, o),
  mi: {
    get: (id) => http.get(API.KPIMI + id),
    getAll: () => http.get(`${API.KPIMI}all/`),
    getWithParam: (o) => http.get(API.KPIMI, o),
    geToChange: (o) => http.post(`${API.KPIMI}entity/`, o),
    put: (o) => http.post(`${API.KPIMI}edit/`, o),
    post: (o) => http.post(API.KPIMI, o),
    delete: (o) => http.post(`${API.KPIMI}delete/`, o),
  },
  hse: {
    getAll: () => http.get(`${API.KPIHSE}all/`),
  },
};

// API URL Specifico
export const hoccard = {
  get: (id) => http.get(API.HOCCARD + id),
  getAll: () => http.get(API.HOCCARD),
  post: (o) => http.post(API.HOCCARD, o),
  put: (o, id) => http.put(API.HOCCARD + id, o),
  delete: (id) => http.delete(API.HOCCARD + id),
  getWithParam: (o) => http.get(API.HOCCARD, o),
  getWithParamYear: (o, year) => http.get(`${API.HOCCARD}`, o),
  downloadTemplate: (idWorksite, o) => http.get(`${API.HOCCARD}template/${idWorksite}`, o),
  //RITM0958798 - HOC Download Fix
  //downloadEditTemplate: (data) => http.get("hoccard/excel/", {params: data.params, responseType:'blob'}),
  downloadEditTemplate: (data) => http.get('hoccard/excel/', { params: data.params, responseType: 'blob', cancelToken: source.token }).then((result) => {
    // Clear The Timeout
    clearTimeout(timeout);
  
    // Handle your response
    return result;
  }),
  //End
  // uploadTemplate: (data) =>
  //  axios({
  //    url: `${process.env.REACT_APP_API_URL}api${API.HOCCARD}template/`,
  //    method: 'POST',
  //    data,
  //    headers: {
  //      'Content-Type': 'multipart/form-data'
  //    }
  //  })
  uploadTemplate: (data) =>
    httpMultiPart.post(`${process.env.REACT_APP_API_URL}api${API.HOCCARD}template/`, data),
  uploadEditTemplate: (data) =>
    httpMultiPart.post(`${process.env.REACT_APP_API_URL}api${API.HOCCARD}importeditexcel/`, data),
  sources: {
    getAll: () => http.get(`${API.HOCCARD}hocCardSources`)
  },
  years: {
    getAll: () => http.get(`${API.HOCCARD}years`)
  }
};
// API URL Specifico
export const registry = {
  get: (id) => http.get(API.REGISTRY + id),
  getAll: (url) => http.get(API.REGISTRY + url),
  post: (o) => http.post(API.REGISTRY, o),
  put: (o, id) => http.put(API.REGISTRY + id, o),
  delete: (id) => http.delete(API.REGISTRY + id),
};

export const tasks = {
  getByMonth: (month) =>
    http.get(API.TASKS, {
      params: { month },
    }),
  getWithParam: (o) => http.get(`${API.TASKS}paged`, o),
  put: (id) => http.put(API.TASKS + id),
  get: (id) => http.get(API.TASKS + id),
};
export const fileUpload = {
  post: (data) => httpMultiPart.post('storage/UploadAsync', data),
};
export const activityLog = {
  getWithParam: (o) => http.get(`${API.ACTIVITYLOG}paged`, o),
  getEntity: () => http.get(`${API.ACTIVITYLOG}entity`),
  getfilteredEntity: (o) => http.get(`${API.ACTIVITYLOG}entityfiltered`, o),
};
// API URL JSCrud
export const dynamic = {
  get: (url, id) => http.get(API.DYNAMIC_CRUD + url + id),
  getAll: (url, o) => http.get(API.DYNAMIC_CRUD + url, o),
  getCalendar: (url, o) => http.get(API.DYNAMIC_CRUD + url, o),
  post: (url, o) => http.post(API.DYNAMIC_CRUD + url, o),
  put: (url, o) => http.put(API.DYNAMIC_CRUD + url, o),
  delete: (url, id) => http.delete(API.DYNAMIC_CRUD + url + id),
};
